export enum ListingType {
  TRAINING_PLAN = "Training Plan",
  WORKOUT = "Workout",
  ASSESSMENT = "Assessment",
  BLOG = "Blog",
}
